import StepHeadding from './StepHeadding';

export default StepHeadding;
